import * as CONSTANTS from 'config/constants';
import { parseJwt } from './functions';

/**
 * Get token payload from localStorage
 */
export const getTokenPayload = () => {
  const token = localStorage.getItem(CONSTANTS.ACCESS_TOKEN);
  return token ? parseJwt(token) : null;
};

/**
 * Get current user's admin role
 */
export const getCurrentUserRole = (): string | null => {
  const tokenPayload = getTokenPayload();
  return tokenPayload?.data?.admin_role || null;
};

/**
 * Check if user has permission based on allowed roles
 * @param allowedRoles - Array of roles that are allowed to access
 * @returns true if user's role is in allowedRoles, false otherwise
 */
export const hasPermission = (allowedRoles: string[]): boolean => {
  if (!allowedRoles || allowedRoles.length === 0) {
    return true; // No restriction, allow access
  }

  const userRole = getCurrentUserRole();
  if (!userRole) {
    return false; // No role found, deny access
  }

  return allowedRoles.includes(userRole);
};

/**
 * Check if user has any of the specified roles
 * @param roles - Array of roles to check
 * @returns true if user has at least one of the roles
 */
export const hasAnyRole = (roles: string[]): boolean => {
  return hasPermission(roles);
};

/**
 * Check if user has all of the specified roles
 * @param roles - Array of roles to check
 * @returns true if user has all roles (usually only one role is used)
 */
export const hasAllRoles = (roles: string[]): boolean => {
  if (!roles || roles.length === 0) {
    return true;
  }

  const userRole = getCurrentUserRole();
  if (!userRole) {
    return false;
  }

  return roles.every((role) => role === userRole);
};

